export default (Bus) => {
  Bus.$on('re-select.created', (vm) => {
    vm.customConfig.wrapperAttrs.class = 'custom-select'
    vm.customConfig.isWrapped = true
  })
}

